import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ViewEncapsulation,
  ElementRef,
  Renderer,
  Optional,
  NgModule
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { OListItemComponent } from '../list-item/o-list-item.component';
import { OListItemTextRenderer } from './o-list-item-text-renderer.class';
import { OSharedModule } from '../../../shared';

export const DEFAULT_INPUTS_O_LIST_ITEM_TEXT = [
  ...OListItemTextRenderer.DEFAULT_INPUTS_O_TEXT_RENDERER,
  'iconPosition : icon-position'
];

export const DEFAULT_OUTPUTS_O_LIST_ITEM_TEXT = [
  ...OListItemTextRenderer.DEFAULT_OUTPUTS_O_TEXT_RENDERER
];



export class OListItemTextComponent extends OListItemTextRenderer {

  public ICON_POSITION_LEFT = 'left';
  public ICON_POSITION_RIGHT = 'right';

  public _iconPosition: string;

  constructor(
    elRef: ElementRef,
    _renderer: Renderer,
    _injector: Injector,
      protected _listItem: OListItemComponent
  ) {
    super(elRef, _renderer, _injector, _listItem);
    this.elRef.nativeElement.classList.add('o-list-item-text');
  }

  ngOnInit(): void {
    if (!this.iconPosition || [this.ICON_POSITION_LEFT, this.ICON_POSITION_RIGHT].indexOf(this.iconPosition.toLowerCase()) === -1) {
      this.iconPosition = this.ICON_POSITION_RIGHT;
    }
  }

  ngAfterViewInit() {
    this.modifyMdListItemElement();
  }

  get iconPosition() : string {
    return this._iconPosition;
  }

  set iconPosition(val : string) {
    this._iconPosition = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-item-text',
  template: `
    <div fxLayout="row" fxLayoutAlign="center center">
      <md-icon *ngIf="icon !== undefined && iconPosition === ICON_POSITION_LEFT" [class.top]="has3Lines" class="material-icons o-list-item-icon"
        (click)="onActionIconClick($event)">{{ icon }}</md-icon>
      <div class="mat-list-text">
        <h3 mdLine class="primary-text"> {{ title }} </h3>
        <h4 *ngIf="primaryText !== undefined" mdLine class="primary-text">{{ primaryText }}</h4>
        <p *ngIf="secondaryText !== undefined" mdLine class="secondary-text">{{ secondaryText }}</p>
      </div>
      <md-icon *ngIf="icon !== undefined && iconPosition === ICON_POSITION_RIGHT" [class.top]="has3Lines" class="material-icons o-list-item-icon"
        (click)="onActionIconClick($event)">{{ icon }}
      </md-icon>
    </div>
  `,
  styles: [`
    .mat-list.selectable[dense] .mat-list-item-content{padding-right:32px}.mat-list.selectable:not([dense]) .mat-list-item-content{padding-right:36px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST_ITEM_TEXT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIST_ITEM_TEXT
  ],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-custom-list-item]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Injector, },
{type: OListItemComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OListItemComponent), ] }, ]},
];
}



export class OListItemTextModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListItemTextComponent],
  imports: [
    CommonModule,
    OSharedModule
  ],
  exports: [OListItemTextComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
